module.exports = "static/assets/32e0021542e34f09a747322d11868f23.mp3";